export class PromptSystem {
  private overlay: HTMLElement | null = null;
  private box: HTMLElement | null = null;
  private resolvePromise: ((value: string | null) => void) | null = null;

  init(overlayId: string, boxId: string): void {
    this.overlay = document.getElementById(overlayId);
    this.box = document.getElementById(boxId);

    this.overlay?.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close(null);
    });
  }

  async alert(message: string, title?: string): Promise<void> {
    return new Promise((resolve) => {
      this.showBox(`
        ${title ? `<h3>${title}</h3>` : ''}
        <p>${message}</p>
        <div class="prompt-buttons">
          <button class="prompt-btn primary" data-action="ok">OK</button>
        </div>
      `, () => resolve());
    });
  }

  async confirm(message: string, title?: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.showBox(`
        ${title ? `<h3>${title}</h3>` : ''}
        <p>${message}</p>
        <div class="prompt-buttons">
          <button class="prompt-btn" data-action="cancel">Cancel</button>
          <button class="prompt-btn primary" data-action="ok">OK</button>
        </div>
      `, (action) => resolve(action === 'ok'));
    });
  }

  async prompt(message: string, defaultValue: string = '', title?: string): Promise<string | null> {
    return new Promise((resolve) => {
      this.showBox(`
        ${title ? `<h3>${title}</h3>` : ''}
        <p>${message}</p>
        <input type="text" class="prompt-input" value="${defaultValue}" />
        <div class="prompt-buttons">
          <button class="prompt-btn" data-action="cancel">Cancel</button>
          <button class="prompt-btn primary" data-action="ok">OK</button>
        </div>
      `, (action) => {
        if (action === 'ok') {
          const input = this.box?.querySelector<HTMLInputElement>('.prompt-input');
          resolve(input?.value ?? null);
        } else {
          resolve(null);
        }
      });
    });
  }

  private showBox(html: string, callback: (action: string) => void): void {
    if (!this.overlay || !this.box) return;

    this.box.innerHTML = html;
    this.overlay.classList.remove('hidden');

    const buttons = this.box.querySelectorAll<HTMLButtonElement>('.prompt-btn');
    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const action = btn.dataset.action ?? 'cancel';
        this.close(action);
        callback(action);
      });
    });

    const input = this.box.querySelector<HTMLInputElement>('.prompt-input');
    if (input) {
      input.focus();
      input.select();
    }
  }

  private close(_result: string | null): void {
    this.overlay?.classList.add('hidden');
    if (this.resolvePromise) {
      this.resolvePromise(_result);
      this.resolvePromise = null;
    }
  }
}
